// File: src/layouts/WithContainer.js
// requirement in layoutConfig (App.js)
export default function WithContainer({ children }) {
  return (
    <div className="min-h-screen bg-transparent pt-20 px-5">
      <div className="p-5 max-w-6xl mx-auto bg-slate-900/70 backdrop-blur-md rounded-xl shadow-xl">
        {children}
      </div>
    </div>
  );
}
